import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useSeo } from "@/hooks/useSeo";
import { finalists } from "@/mocks/finalists";
import RankingBoard from "./components/RankingBoard";

export default function RankingPage() {
  useSeo({
    title: "爆料大赛排名结果 - 群众打分实时榜单 | 爆料大赛",
    description:
      "爆料大赛排名结果实时更新，查看群众打分走势与入围作品得分榜，围观本周上升最快与口碑最稳的候选作品。",
    keywords: "爆料大赛排名结果,爆料大赛群众打分,爆料大赛榜单,爆料大赛投票结果",
    path: "/ranking",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "爆料大赛排名结果",
        inLanguage: "zh-CN",
        description: "爆料大赛群众打分实时排名榜与 7 日得分走势。",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "排名结果", item: "/ranking" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "爆料大赛群众打分排行榜",
        itemListElement: [...finalists]
          .sort((a, b) => b.score - a.score)
          .map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.title,
          })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-[68px]">
        <div className="w-full bg-background-100 border-b border-background-200">
          <div className="mx-auto max-w-6xl px-4 md:px-8 py-10 md:py-14">
            <Breadcrumb items={[{ label: "排名结果" }]} />
            <h1 className="mt-4 font-heading text-3xl md:text-5xl tracking-wide text-foreground-950">
              群众打分排名结果
            </h1>
            <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              榜单随投票持续刷新。你可以查看全网作品的得分排序，也可以关注每件作品短期内的高低变化，看看谁正在悄悄冲榜。
            </p>
          </div>
        </div>
        <RankingBoard />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}